// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__27n8H","itemTitle":"ClientEmergencyInfo_itemTitle__3ZqeH","itemText":"ClientEmergencyInfo_itemText__LG3PY"};